var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.sites,"items-per-page":10},scopedSlots:_vm._u([{key:"item.last_date",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.usaDate(item.last_date))+" ")]}},{key:"item.edit",fn:function(ref){
var item = ref.item;
return [_c('v-btn',{staticClass:"table-button",attrs:{"small":"","to":("/site/" + (item.id))}},[_vm._v("Edit")])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }